import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { Skeleton } from "@/components/ui/skeleton";
import { usePlatformOperator } from "@/modules/platform/platformApi";

/** Renders children for platform operators; everyone else goes home. */
export const PlatformGuard = ({ children }: { children: ReactNode }) => {
  const { data: isOperator, isPending } = usePlatformOperator();
  if (isPending) return <Skeleton className="h-24 w-full rounded-xl" />;
  if (!isOperator) return <Navigate to="/" replace />;
  return <>{children}</>;
};
